// extracted by mini-css-extract-plugin
export default {"currentUser":"CurrentUser_currentUser__EYmOa form_footnote__CvXi3","b":"CurrentUser_b__t3Sel"};